import request from '../helpers/request';
import { payment } from './apiMapping';

/**
 * Get possible payment methods
 *
 * @returns {Promise}
 */
const getPaymentDataList = () => request(payment.getPaymentDataList);

export { getPaymentDataList };